import {EditPopup} from "../Detail2/components/EditPopup";

export const Add = () => {
    return <EditPopup tableName='activity_test_instance_kr' id={-1} isAdding={true}/>
}